const authRoutes = [
  { path: "", redirect: "/login" },
  {
    path: "/login",
    name: "desktopLogin",
    component: () => import("../views/mobile/auth/Login.vue")
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/mobile/auth/Register.vue")
  },
  {
    path: "/password",
    name: "ResetPassword",
    component: () => import("../views/mobile/auth/Password.vue")
  }
]
export const baseline = {
  path: "baseline",
  component: () => import("@/views/mobile/project/baseline/Index.vue"),
  children: [
    {
      path: "profile",
      component: () => import("@/views/mobile/project/baseline/profile/Index.vue"),
      meta: { sbCode: 20200 }
    },
    {
      path: "equipment",
      component: () => import("@/views/mobile/project/baseline/equipment/Index.vue"),
      meta: { sbCode: 20300 }
    },
    {
      path: "observation",
      component: () => import("@/views/mobile/project/baseline/observation/Index.vue"),
      meta: { sbCode: 20400 }
    },
    {
      path: "baselineCfg",
      component: () => import("@/views/mobile/project/baseline/baselineCfg/Index.vue"),
      meta: { sbCode: 20500 }
    },
    {
      path: "baselineList",
      component: () => import("@/views/mobile/project/baseline/baselineList/Index.vue"),
      meta: { sbCode: 20610 }
    },
    {
      path: "preview",
      component: () => import("@/views/mobile/project/baseline/preview/Index.vue"),
      meta: { sbCode: 20700 }
    },
    {
      path: "report",
      component: () => import("@/views/mobile/project/baseline/preview/Index.vue")
    }
  ]
}

export const proposed = {
  path: "proposed",
  component: () => import("@/views/mobile/project/proposed/Index.vue"),
  children: [
    {
      path: "condition",
      component: () => import("@/views/mobile/project/proposed/condition/Index.vue"),
      meta: { sbCode: 20800 }
    },
    {
      path: "equipment",
      component: () => import("@/views/mobile/project/proposed/equipment/Index.vue"),
      meta: { sbCode: 20900 }
    },
    {
      path: "solution",
      component: () => import("@/views/mobile/project/proposed/solution/Index.vue"),
      meta: { sbCode: 21000 }
    }
  ]
}

export const wizardDetails = {
  path: "",
  component: () => import("@/views/mobile/wizard/WizardMain.vue"),
  children: [
    {
      path: "minInput",
      component: () => import("@/views/mobile/wizard/minInput/MinInput.vue")
    },
    {
      path: "reviewAssumptions",
      component: () => import("@/views/mobile/wizard/reviewAssumptions/ReviewAssumptions.vue")
    },
    {
      path: "proposedSolution",
      component: () => import("@/views/mobile/wizard/proposedSolution/ProposedSolution.vue")
    }
  ]
}

export const mobileRoutes = [
  ...authRoutes,
  { path: "/home", component: () => import("@/views/mobile/home/Home.vue") },
  { path: "/admin", component: () => import("@/views/mobile/admin/Admin.vue") },
  { path: "/userSetting", component: () => import("@/views/mobile/userSetting/userSetting.vue") },
  { path: "/account", component: () => import("@/views/mobile/admin/account/Account.vue") },
  { path: "/ecat", component: () => import("@/views/mobile/admin/ecat/Ecat.vue") },
  { path: "/customized", component: () => import("@/views/mobile/admin/ecat/CustomizedDetails.vue") },
  { path: "/feedback", component: () => import("@/views/mobile/admin/feedback/Feedback.vue") },
  { path: "/my", component: () => import("@/views/mobile/My/My.vue") },
  { path: "/about", component: () => import("@/views/mobile/My/about/About.vue") },
  { path: "/nomenclature", component: () => import("@/views/mobile/My/nomenclature/Nomenclature.vue") },
  { path: "/dashboard", component: () => import("@/views/mobile/dashboard/Dashboard.vue") },
  { path: "/usefultools", component: () => import("@/views/mobile/My/usefulTools/UsefulTools.vue") },

  {
    path: "/project",
    component: () => import("@/views/mobile/project/Project.vue"),
    children: [{ path: "objective", component: () => import("@/views/mobile/project/objective/Objective.vue") }, { ...baseline }, { ...proposed }]
  },
  // {
  //   path: "/demo",
  //   component: () => import("@/views/mobile/project/commons/demo/Demo.vue")
  // }
  {
    path: "/wizard",
    component: () => import("@/views/mobile/wizard/Wizard.vue"),
    children: [
      // {
      //   path: "objective",
      //   component: () => import("@/views/mobile/wizard/objective/Objective.vue")
      // },
      { ...wizardDetails }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/mobile.js